var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imagem-nao-disponivel"},[_c('i',{staticClass:"fa fa-camera"}),_c('p',[_vm._v("Imagem não disponível")])])}]

export { render, staticRenderFns }